import { SkeletonText, Tooltip } from '@chakra-ui/react';
import Invite from '../../assets/images/invite-friend.webp';
import PropTypes from 'prop-types';
import { classNames, formatToCurrency } from '../../utils/common';

const isOffer = (rechargeable_type) =>
  rechargeable_type === 'App\\Models\\OfferProduct';

const currencies = {
  eur: '€',
  usd: '$',
};

const InfoCheckout = ({
  checkoutData,
  contacts = [],
}) => {
  const titleRechargeable = contacts[0]?.phone
    ? `Número${contacts.length > 1 ? 's' : ''} a recargar`
    : contacts[0]?.email
    ? `Cuenta${contacts.length > 1 ? 's' : ''} a recargar`
    : '';
  const rechargeable = contacts[0]?.phone
    ? contacts.map((c) => `+53${c.phone}`)
    : contacts.map((c) => c.email);

  const sliceableNumb = contacts[0]?.phone ? 5 : 3;

  return (
    <div className="flex flex-col gap-6 items-center justify-center max-w-md">
      {/* Image + offer */}
      <div className="flex flex-col">
        <img
          src={Invite}
          alt=""
          className="aspect-auto z-0 w-[80%] md:w-[100%] mx-auto -mt-10 md:mt-0"
        />

        <div
          className={classNames(
            'flex md:flex-row -mt-5 z-10 items-center gap-2 md:gap-3 mx-auto w-full rounded-lg shadow-md p-2 px-4 md:p-6 text-white transition-colors',
            isOffer(checkoutData?.rechargeable_type)
              ? 'bg-yellow-primary'
              : 'bg-primary',
          )}
        >
          <div className="flex flex-col grow gap-1 md:gap-2 w-full">
            <SkeletonText
              w={150}
              skeletonHeight={5}
              noOfLines={1}
              startColor="gray.100"
              endColor="gray.500"
              isLoaded={checkoutData}
              className="whitespace-nowrap"
            >
              <span className="text-[10px] lg:text-xl font-bold">
                {checkoutData?.rechargeable_object?.name}
              </span>
            </SkeletonText>
            <SkeletonText
              skeletonHeight={9}
              noOfLines={1}
              startColor="gray.100"
              endColor="gray.500"
              isLoaded={checkoutData}
              className={contacts?.length > 0 ? 'lg:w-[250px]' : 'full'}
            >
              <span className="text-[11px] lg:text-2xl font-bold uppercase truncate-2-lines">
                {checkoutData?.rechargeable_object?.description}
              </span>
            </SkeletonText>
          </div>

          {/* Total to pay */}
          {checkoutData?.total_amount_pay && (
            <div className="flex flex-col md:gap-3 text-white">
              <div className="text-[10px] lg:text-sm border-b-[1px] whitespace-nowrap border-b-white font-semibold w-full pb-[2px] md:pb-2">
                Total a pagar
              </div>
              <SkeletonText
                className="md:max-w-[424px]"
                skeletonHeight={10}
                noOfLines={1}
                startColor="gray.100"
                endColor="gray.500"
                isLoaded={checkoutData}
              >
                <span className="text-2xl lg:text-5xl font-black whitespace-nowrap">
                  {formatToCurrency(checkoutData.total_amount_pay)}{' '}
                  {currencies[checkoutData?.currency] || ''}
                </span>
              </SkeletonText>
            </div>
          )}
        </div>
      </div>

      {/* Phone or Account to recharge */}
      <div className="w-full block px-8">
        <span className="text-2xl font-bold text-blue-primary">
          {titleRechargeable}
        </span>
        <div className="flex flex-wrap gap-2 rounded-2xl py-3">
          {rechargeable.slice(0, sliceableNumb).map((r, i) => (
            <div
              key={i}
              className="bg-gray-200 text-gray-600 text-[13px] select-none whitespace-nowrap rounded-full px-3 py-1 justify-center items-center"
            >
              {r}
            </div>
          ))}
          {rechargeable.length > sliceableNumb && (
            <Tooltip
              label={rechargeable.slice(sliceableNumb, rechargeable.length).join(' ')}
              placement="top"
              openDelay={500}
            >
              <div className="text-[15px] w-fit text-gray-500 hover:text-gray-700 hover:underline underline-offset-2 px-3 mt-0.5">
                {`+${rechargeable.length - sliceableNumb} más`}
              </div>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
};

InfoCheckout.propTypes = {
  checkoutData: PropTypes.shape({
    id: PropTypes.number,
    rechargeable_object: PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
    }),
    total_amount_pay: PropTypes.number,
    currency: PropTypes.string,
    rechargeable_type: PropTypes.string,
    type: PropTypes.string,
  }),
  contacts: PropTypes.array,
};

export default InfoCheckout;
